module.exports = __webpack_public_path__ + "static/media/Express Logo.e7256fcc.png";